import { getValue, isPending } from 'mobx-async'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { BookingsTapeChartStore } from '@new/domains/bookingsTapeChart/stores/BookingsTapeChartStore'

interface HighlightsFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _HighlightsFilter: FC<HighlightsFilterProps> = props => {
  const { highlightsOptions } = BookingsTapeChartStore

  const options = getValue(highlightsOptions)
  const isLoading = isPending(highlightsOptions)

  return (
    <CheckboxBasedFilter
      title="Highlights"
      isSearchEnabled
      searchPlaceholder="Search by highlight"
      isLoadingOptions={isLoading}
      options={options}
      {...props}
    />
  )
}

export const HighlightsFilter = observer(_HighlightsFilter)
